import { CoreAddressesModel } from '@models/core-addresses.model';

import { TokenInfo } from './addresses.constant';

export const GETH_CORE = new CoreAddressesModel(
  '0x6f74b8A0466f75E9c19CC55757185757f0Ed123c', // controller
  '0x90Ea96DBA5bbbb4D2F798C47FE23453054c0FAB4', // gameToken
  '0xb29DCf19c4a0A902319BaB29f6301c70961806f3', // minter
  '0x1a563E54B6b684fC523E2D306F405B6ec4Bd41fA', // goc
  '0xf01a741aAa039627CEf3d3F1e4f680A488698F35', // reinforcementController
  '0x40Bbe7C4dB709Cd54F50f873F02Ce3ac800FE06E', // dungeonFactory
  '0xD4Ab57054f012bF49abcB7C868431b17117349E3', // heroController
  '0x1Fec355130943AbED730799Ed15fE893958AaA24', // itemController
  '0xeb04b9Af47DbcA4347BCAe3d044990008C7cb4d1', // oracle
  '0xA34007eF7E844E7F13df325cCD0562b99A2a7bF9', // statController
  '0x189EFaBEBd2C368cF8504eaD6154d40434273009', // storyController
  '0x30809E2bBD6c82C7ae10737e5f6F6e723D06ca73', // treasury
  '0x8ee15B395f6c18eFECbde6806507637499693D23', // statReader
  '0xE1866ebc74355F8E62383957bDd0eD26F47f88e1', // multicall
  '0x90Ea96DBA5bbbb4D2F798C47FE23453054c0FAB4', // magicToken
  '0x90Ea96DBA5bbbb4D2F798C47FE23453054c0FAB4', // strengthToken
  '0x90Ea96DBA5bbbb4D2F798C47FE23453054c0FAB4', // dexterityToken

  '0x12c4289C673809d8520ca209aA87b06A768aF8bc', // pawnsop
  '0xc5E3f7037B925F416C576b699BAc2477c2e9C6d2', // PawnShopRouterFactory
  '0x90Ea96DBA5bbbb4D2F798C47FE23453054c0FAB4', // network token
  '0x9C7B1ae45fd9c51dFF1f91ecB916b067d3Bd16e5', // sponsored hero
  '0x0000000000000000000000000000000000000000', // relay
  '0xD6AD037c491C51852E01777f3F8a78947d0F5585', // data storage
  '0x52bae856d5635215227ED0d46d047Ac48CF2C8d4', // user controller
  '0xA6EDa098c893318bC3dc0a8392BeA10F6c384ED7', // ITEM:controller helper
  '0x4BF69C5Dc65fBf3b15C3C9EF57B79e5942afB1D7', // guild controller
  '0x21346b73395a3199bd25Caec19051d259dAE6Fa3', // shelterController
  '0x6962D2e1D42639E5d1053fed015cd8f5E216EC2a', // shelterAuctionController
  '0xaf22A04a10c94518D6F1008Ed447432507d5a776', // rewardsPool
  '0x3EbB6fdDfda1B1D1F9A84a157858FE07Ff02289c', // pvp controller
  '0x967d4F7896d4cA532F2714893371aAE8fa24e5E4', // ITEM:box controller
  '0x0000000000000000000000000000000000000000', // guildStakingManager
);

export const GETH_GAS_FAUCET = '0x49c889375b2680c76F06A4524133dD4F6A426969';

export const GETH_TOKEN_INFO = new Map<string, TokenInfo>([
  [GETH_CORE.gameToken.toLowerCase(), { symbol: 'SACRA', decimals: 18 }],
  [GETH_CORE.magicToken.toLowerCase(), { symbol: 'SACRA', decimals: 18 }],
  [GETH_CORE.networkToken.toLowerCase(), { symbol: 'SACRA', decimals: 18 }],
]);

export const GETH_ITEMS = {
  SACRA_CONS_1_ITEM: '0x5e02c2741c5530311028a68888633c2a6a9d1f24',
  SACRA_CONS_2_ITEM: '0xe517ce7e187fb9adb947ea0d5275ddb8c225b9a0',
  SACRA_CONS_3_ITEM: '0x0735dabd0ba078200effb5702f4d424dccb98370',
  SACRA_CONS_4_ITEM: '0x5524f596c06fa4c19e5f2723e9bf8d41b9e7311c',
  SACRA_CONS_17_ITEM: '0xdcdfb5e517329d01170624a66ec105d56210eb83',
  SACRA_CONS_18_ITEM: '0xc52fb290ba410363378f996ec9fb1f17a256115f',
  SACRA_CONS_19_ITEM: '0x7852608dd18578e51d163c0885563bd83187dc73',
  SACRA_CONS_20_ITEM: '0x9f292c197eee5838cd24ad99f96635e0185d4686',
  SACRA_CONS_21_ITEM: '0x6f1b598ccf953ccf7d0efc906b44e776ef1185e7',
  SACRA_CONS_27_ITEM: '0x4ce34dea756545b23a79dd350d890a46cb26a09d',
  SACRA_CONS_28_ITEM: '0x3c57a042c22b32d6631e00a10535150fa01047e1',
  SACRA_CONS_29_ITEM: '0xe3243527d7376ad5b455d1830318698defe93cde',
  SACRA_CONS_35_ITEM: '0xe689511891f2e5d1a2040333fee2be66abb9ab6b',
  SACRA_OTHER_1_ITEM: '0x85b9bc2abb549cbd77141c712dd8ade84fe4e987',
  SACRA_OTHER_2_ITEM: '0x7963e4348ae283596c1721ecde1255f4616819fd',
  SACRA_OTHER_3_ITEM: '0xbbb5802d7cc5072d9f4bbfc30a30e6c4135c8895',
  SACRA_OTHER_4_ITEM: '0x3c866e48674b3787bf9c7ddc55bfc95e13e404d7',
  SACRA_OTHER_5_ITEM: '0x8596a51f50204909d417c12e9cb5e9603cb686cf',
  SACRA_HELM_1_ITEM: '0x0baa5ac85a7339e17f56a8761fb6e2ce6499d91e',
  SACRA_HELM_6_ITEM: '0x58e777ec498609f9a4a319d71a2b9f9a5235d252',
  SACRA_HELM_9_ITEM: '0x7e0129115323e043d0593e8431a5bf875f32b2ca',
  SACRA_BODY_1_ITEM: '0x2bd1863ab163c28fab016ab722ebc12055d07231',
  SACRA_GLOVES_1_ITEM: '0xf713fcb1af9d96a19d91b84537f0d6480dd05699',
  SACRA_GLOVES_6_ITEM: '0xdb6f8f651d6fb17e35c7c808216ad01d238c04be',
  SACRA_BELT_1_ITEM: '0x755e4ef32ffa817df0e21aa40ad81aefac71d1db',
  SACRA_BELT_5_ITEM: '0x615c7632cc5b6de13747694427daa3b823e7ddd7',
  SACRA_AMULET_1_ITEM: '0x90063fda68d4cc29c64dda42ad675f53a495f320',
  SACRA_AMULET_2_ITEM: '0x276eda01c8f979570a177a4f828362eeafa81214',
  SACRA_AMULET_12_ITEM: '0x2f6ced105f3f33b8a2badde1280d475d82f89ced',
  SACRA_AMULET_13_ITEM: '0x917a338f77973f5f6a06cb3207a225597119f059',
  SACRA_RING_1_ITEM: '0x2608aecd1699327715af4d925f390d5467fafa51',
  SACRA_RING_2_ITEM: '0xa90fe35c7260226a1dcc4d8d9ad12e6284624a11',
  SACRA_RING_9_ITEM: '0xecea74ca8450ac8e4926b41f43331353c9d79d22',
  SACRA_OFF_1_ITEM: '0x8ec136daa624b0916d1d8e9b755ea36d84e2d0bc',
  SACRA_OFF_2_ITEM: '0x0d90c7c69517bb6b3956077a27489d2e3a0b822d',
  SACRA_OFF_10_ITEM: '0x85502435ab6688cd1b9c36174dabed15175e6811',
  SACRA_BOOTS_1_ITEM: '0xc775da9fbebd435c7b0fa259adeee2105c045881',
  SACRA_BOOTS_5_ITEM: '0x212bda54e79e68cc76de172e797c4ca60cb1ce95',
  SACRA_OHW_1_ITEM: '0x341e63d8e549459b54761eeed80774c2b3067af8',
  SACRA_OHW_2_ITEM: '0xf508f7bc6f1fdaebc398ac97b13da6c0dea5fd6a',
  SACRA_OHW_3_ITEM: '0xef68e25bdd131f99378f3bfba026ae2dc11860e4',
  SACRA_THW_1_ITEM: '0xf914405f0b634ea7dbb06e06c3075c8fe0533c6d',
  SACRA_THW_2_ITEM: '0xf14adfccb89be2823bf56d507803a62d37a19eb5',
  SACRA_FEAR_ITEM: '0xfcc2444591e0312e1179e5017de6b1e5285cc92f',
  SACRA_DEMON_SPEED_ITEM: '0x886187607dc660d038259571d55150d929be3531',
  SACRA_BRUTE_FORCE_ITEM: '0x8408885fa2ec77670ca92efb32238dcb6a1986a9',
  SACRA_SAVAGE_CHARM_ITEM: '0x4dbe554e4dc1b6cb6b7b434748b60dcd29738115',
  SACRA_GOLDEN_EYE_ITEM: '0xb06e421682049490c5898c8339b1cc28b2bfa81a',
  SACRA_SABBAH_POISON_ITEM: '0xb13075bb0753df54d78507add8a6143b2a8c382e',
  SACRA_SPIT_IN_FACE_ITEM: '0x7beba8172d840d3fcaca073c997f309a1203ec5e',
  SACRA_ONSLAUGHT_ITEM: '0xbbc5fade114cc837da7787c20c6ef29ab6e216e6',
  SACRA_STRONG_BLOCK_ITEM: '0x04d010e743d6eeb009a9fbf57fcd1d6f9e53c726',
  SACRA_BEEF_PATTY_ITEM: '0x3b7c62666ed917184c0900434082b8cf9c655373',
  SACRA_HEAT_STRIKE_ITEM: '0xed9f96db870aa6190e9b87e93a342b33746c4937',
  SACRA_STATIC_DISCHARGE_ITEM: '0xfee6913d8942750bcf49359977caf97115a97eca',
  SACRA_CONS_5_ITEM: '0x1538e857827749bc7d2853bcab6c20f94da8b225',
  SACRA_CONS_6_ITEM: '0xc4aabd177d8bf3ba3ce59216c107de7ac4a567a0',
  SACRA_CONS_7_ITEM: '0x7d4561a85f9f8007fef06c9e674358f87a79cc67',
  SACRA_CONS_8_ITEM: '0x628eac6096be3dcc8969b99bdef9f9db2f5e2f1b',
  SACRA_CONS_22_ITEM: '0x2749b47d508b926f0ad315f9a08a15e2d43178c8',
  SACRA_CONS_30_ITEM: '0xbc153103d19a7bf2e783d8c525fc071addf4d5ad',
  SACRA_HELM_2_ITEM: '0x70cdb80376b97b0cb35e5f8b7e479c4105338302',
  SACRA_HELM_7_ITEM: '0xc99c68ac7621a562a94ed7f06706fca8f13f9ade',
  SACRA_BODY_2_ITEM: '0x253a6406f415500bd5f3535658aa37306fe1b1c3',
  SACRA_BODY_6_ITEM: '0xe97910782cfc0376c158f0ed156f3a809a5fbbdb',
  SACRA_BODY_8_ITEM: '0xdf5facda14236001e1ea155bddab18a9015cd690',
  SACRA_GLOVES_2_ITEM: '0x36f81d3dd7bdf5c84cff9c4fe7069c5f9ddbbd35',
  SACRA_GLOVES_7_ITEM: '0xc22f8d87f3c84e38c997f5b2c09b1f682f451155',
  SACRA_BELT_2_ITEM: '0xa8617c04b4f5cfa006931edc88cfbf4a1e557773',
  SACRA_BELT_8_ITEM: '0xde8252ea546b2a4f7e18b80311a76d152fb18fe8',
  SACRA_AMULET_3_ITEM: '0x21a837f971606345004a038cc09342cf628353ec',
  SACRA_AMULET_4_ITEM: '0xe4a148dbf0d604e2271845707d30e422558d7a6f',
  SACRA_AMULET_9_ITEM: '0xed0b3a530fcb34731814a220a7ec41785f0d2994',
  SACRA_RING_3_ITEM: '0x7a634bef949d6da53ecd66defb46aaf886343be3',
  SACRA_RING_4_ITEM: '0x9124a1bc2dc1c0925febc738509a4502cb460faf',
  SACRA_RING_10_ITEM: '0x2e70ddfecb3b6455b68d7d87e4dd2d51b2ddd0da',
  SACRA_RING_11_ITEM: '0xc4a838ea147ff3373d29de741a87824475ca871f',
  SACRA_OFF_3_ITEM: '0x612a10f0ba1b0e97095f7dc2e9ecee9130828af1',
  SACRA_OFF_4_ITEM: '0x4f40e032fb16f2d1b301a7a91fe6b7ea1d28cbbb',
  SACRA_OFF_11_ITEM: '0x965c8e75e354c0f44a9c604528018c16472f5764',
  SACRA_BOOTS_2_ITEM: '0x07061fa679ca621c268b63796a57a90a46439a08',
  SACRA_OHW_4_ITEM: '0xe36cc123339d533147587f05b6971aed002d50f4',
  SACRA_OHW_5_ITEM: '0xb438cd5c42ffd10f379a95f52eb568a70837263d',
  SACRA_OHW_6_ITEM: '0xcead804c117f2766ad467a9e058aacce6408a637',
  SACRA_OHW_20_ITEM: '0xc5788ac84d627017c132b4fc370513563ba5e624',
  SACRA_THW_3_ITEM: '0xa429722f842640d124eff5e3b5875e13a53a36de',
  SACRA_THW_4_ITEM: '0xdd5498be15758948810ed6dd7fb00afa721a0823',
  SACRA_THW_5_ITEM: '0x92d06690acd5bfbac2b254d9a1f51716856397fc',
  SACRA_STEEL_SKIN_ITEM: '0xf10ec53a041747c4b0df83aa5a27f14e2337cafc',
  SACRA_LIFEDRAIN_ITEM: '0x7213e44a8cc13e482bfe3f5d3f796a4d0849fc3e',
  SACRA_FROSTBITE_ITEM: '0x7b256ecf6c7cfc0fb0b4ae817cf3d25581e838d4',
  SACRA_LIKE_A_PUSSY_ITEM: '0xd59471768a31d3943371f76be8c2b9acdca24630',
  SACRA_RAGE_ITEM: '0x45a79fd6f9bc7bb71705fedd18e5f29e685eb795',
  SACRA_DEAD_STRIKE_ITEM: '0xe39bf4d4a7da7c375787963721d618f5442191e6',
  SACRA_FIRM_HAND_ITEM: '0x7364e7bdff9350bd8e4557f55493c43fb53433cb',
  SACRA_JUSTICE_ITEM: '0x44e37097eb56ebd4552d2e681ada197008ce185e',
  SACRA_STEP_BACK_ITEM: '0x87f8113cc38f76b9181b257158a146c4f9ac2e1e',
  SACRA_PATIENCE_ITEM: '0x32c14d6e78ba759dbccea774d54c43874744482a',
  SACRA_TIME_AND_EXPERIENCE_ITEM: '0x17c50748bc06efe6fc94f190d2e0194ae11b2d02',
  SACRA_MELT_ITEM: '0x55604bd2c407859becbea96fd61d1c5aa0e87c7a',
  SACRA_ICE_SHARD_ITEM: '0x6df60a250d4d03216ca26e74f67955114ff1a03f',
  SACRA_CONS_9_ITEM: '0xdeb73e9c5277a4ece6f85ae10cfbee2dd3b831b1',
  SACRA_CONS_10_ITEM: '0xb9e65ebdc3a80c05440f8a91697ee8444710075b',
  SACRA_CONS_11_ITEM: '0x9ea8dba2e25fc84d0979547479f16d89e222edf6',
  SACRA_CONS_12_ITEM: '0x3a3f2f0325ddd9dff2da680777d46c71c0c48402',
  SACRA_CONS_23_ITEM: '0x99bc8df0ce095d81ec9e0e5321f6211bcaf2334d',
  SACRA_CONS_24_ITEM: '0x2dd2494de12453977bb1a70b4124efcc1e41d311',
  SACRA_CONS_31_ITEM: '0xddb6e37ca79cce7ab6702d913a8ccb72d95786eb',
  SACRA_HELM_3_ITEM: '0x8c4264714e9011cf0700f2c5d9a547962eea3078',
  SACRA_HELM_8_ITEM: '0x0cf90c159d338aec82fa8a15e6ceeb7acb978842',
  SACRA_HELM_12_ITEM: '0x873066781db0bcbd6170cf028367cf11b4c164dc',
  SACRA_BODY_3_ITEM: '0x07274864f5460367bd06ab1093289991229df558',
  SACRA_BODY_7_ITEM: '0x1aec1ddf36bdb4ec12e04153bb31bc8b8d25f415',
  SACRA_BODY_12_ITEM: '0xa241e0519861bfa6b4e17115f95c38015af03945',
  SACRA_GLOVES_3_ITEM: '0xe30f7da42485ac1b71650e75074a8b944f1bcec5',
  SACRA_GLOVES_8_ITEM: '0x50912785ebcd4189f8e401e749c6af416a18e910',
  SACRA_GLOVES_12_ITEM: '0xf670a7dc1a7e881d7e03b4c056e60e2c08eb02c1',
  SACRA_BELT_3_ITEM: '0xf8e892879373332352573b76b22c8b57532426b9',
  SACRA_AMULET_5_ITEM: '0xe47f8e38fbf31e171b39d70550188dd7982cab10',
  SACRA_AMULET_6_ITEM: '0x56e798ea6e0b9475d90398bc3b15bc202bed2be2',
  SACRA_AMULET_10_ITEM: '0x13cc114cdf9a28ad484957b481ea3e33942c2b87',
  SACRA_AMULET_11_ITEM: '0xbcc050095b37158150af217827a8891a651d267e',
  SACRA_RING_5_ITEM: '0x8aa801c61b53512c6b58286439f10761605d701e',
  SACRA_RING_6_ITEM: '0x6e99bd4a15105dcd54512e5ed91557b0cc4d7293',
  SACRA_OFF_5_ITEM: '0x2c71db22c0890884af1bc72c13f81077a7d53b4f',
  SACRA_OFF_6_ITEM: '0xc17007a8169e77c72f25d2be4e89ab6b3e5716cd',
  SACRA_OFF_17_ITEM: '0x9a46f43908220d47a1abe970f7304c61a19c7d68',
  SACRA_BOOTS_3_ITEM: '0xfc2f71960453fb43e4bbc8287b670cba64b4a56a',
  SACRA_BOOTS_6_ITEM: '0xd9e683fd670d510dcedc645ee8e58875a05814e7',
  SACRA_BOOTS_12_ITEM: '0x739880a4ac3c73da04a3fa1176e8b8232c918dd3',
  SACRA_OHW_7_ITEM: '0xa4b582b7ae959efc9a28d7eb5c5ecede58e2aeb1',
  SACRA_OHW_8_ITEM: '0x0faa97ca1c0734d2d10f444b30c7e64c86078fbe',
  SACRA_OHW_9_ITEM: '0x3c9037fd611ba749ef2cf234621b58e6ff6daa1b',
  SACRA_OHW_12_ITEM: '0xa826d9884aec08dd065978bc8bfe52cc9af60008',
  SACRA_OHW_13_ITEM: '0x02e28a5ee29e88c82aa1db43e604f3d202741a77',
  SACRA_OHW_14_ITEM: '0x261c4546f1ea0f953a078e2734525bb22c6a3ac5',
  SACRA_THW_6_ITEM: '0x4b62ef1609a7568b79a365bf7a2803f5f86eac75',
  SACRA_THW_7_ITEM: '0x31e53bb39c0211395a4a335d09f69009a3beec30',
  SACRA_THW_10_ITEM: '0x1eedd553227190e7a9b636b4d3b2415d2091c632',
  SACRA_THW_15_ITEM: '0xa28105bc51561d3c5bf892565973290a1a31dc09',
  SACRA_PARALYZE_ITEM: '0x5c39eb12776a0494f71f932174a941f32ba567e0',
  SACRA_GUIDING_LIGHT_ITEM: '0x86d31ac7fb35019fb63de8a3b5af70aa3b7c924e',
  SACRA_GUT_PUNCH_ITEM: '0xa99f905356ef77694ac562e08b2bb60e91cbef2d',
  SACRA_LAST_DANCE_ITEM: '0x5700871c69e0ecc834474a0410a655ba66355893',
  SACRA_I_SURVIVE_ITEM: '0x6f31f73655e400485847b87d499c855f855a460f',
  SACRA_ARMOR_OF_FAITH_ITEM: '0xd57d42990272cc8238c079ff4797cf13b5682df4',
  SACRA_THUNDERBOLT_ITEM: '0xdd771544671215b20dcc64f784791b6597b133b7',
  SACRA_CONS_13_ITEM: '0x259654b5154e344ffe56d3cbbc1267345b27dbcd',
  SACRA_CONS_14_ITEM: '0xb04ee083405a663c345a45e49e4a917372a28f27',
  SACRA_CONS_15_ITEM: '0x64c72d36db8059e29060978f1faed03ea87c117a',
  SACRA_CONS_16_ITEM: '0x31eceb4f63172485f2271f1d7fc41c214fa7b5a3',
  SACRA_CONS_25_ITEM: '0x891518339ecbd316da1477cf61994c76f6d5a2b6',
  SACRA_CONS_26_ITEM: '0xc8bd2b33c3e85e27941373d2dba7caa6e686b058',
  SACRA_CONS_32_ITEM: '0x3c334836ec2b1f0eaf4190484232acb3e1a23e36',
  SACRA_HELM_4_ITEM: '0x1514a7529fe870c5d22ff819b20065953beeb43a',
  SACRA_HELM_5_ITEM: '0x1322ca598c5b78bb95fea767540d73c5a96a24ab',
  SACRA_HELM_13_ITEM: '0x93961a294488c10745471a4c567d4ee648970944',
  SACRA_BODY_4_ITEM: '0x6dfddef7940a9fd2be208127ca385356895eade2',
  SACRA_BODY_5_ITEM: '0xb45d3b7f20b1f1aaa9c845a737a72370512a1d94',
  SACRA_BODY_13_ITEM: '0x4cb535530183b15c3845d3c5a92ced968772a80b',
  SACRA_GLOVES_4_ITEM: '0x93644cc55c3a7e550a07c48eb872f83f9da1724c',
  SACRA_GLOVES_5_ITEM: '0xc1b01fb425464beadd200c58ddead94b50128a9e',
  SACRA_GLOVES_13_ITEM: '0x3fb467b09c993257b69d1630a5e203fb5415e5a5',
  SACRA_BELT_4_ITEM: '0x2a8eb935e1a34460a915f27443aeb91dba838db4',
  SACRA_AMULET_7_ITEM: '0xa6f1d8ceef6f3cdfb59877341e63877c88f70bda',
  SACRA_AMULET_8_ITEM: '0xfd9508e987034bcdf07197c9f7b146c9dff6eece',
  SACRA_RING_7_ITEM: '0xb9a3f53e8455ca9723190b86ffa25a65846c76d6',
  SACRA_RING_8_ITEM: '0xb02dc9ba8f81db8cabe5a5adb586a6662e795314',
  SACRA_RING_15_ITEM: '0x82b62292bd7ea1c13fa1674b510831d775805eb0',
  SACRA_OFF_7_ITEM: '0xc559be81bb242e9e8b4871e1a4c31394adfd7aac',
  SACRA_OFF_8_ITEM: '0xd6c9a242961b195139ce0f0861bf0c6802029f26',
  SACRA_OFF_9_ITEM: '0x9d66a791ba142e22a4d32bf8b8ccdadfb8ea7342',
  SACRA_OFF_12_ITEM: '0x8d889b4966f2663a952765d23ceeeb615ac2e35c',
  SACRA_OFF_13_ITEM: '0x945b967d59ef4f1a16d76a9d197f59f5c3d8dd1d',
  SACRA_BOOTS_4_ITEM: '0xe99dc354717e5cce8c6404aca2513ef3b28a5898',
  SACRA_BOOTS_7_ITEM: '0x08feb2e13ff01810826075aad91c2f52812b9e43',
  SACRA_BOOTS_13_ITEM: '0x2e561c41b5ad022272ecc3e49b89ebce12e775ee',
  SACRA_OHW_10_ITEM: '0x45589540c085715c5646383824e7a6b1ed5c9b53',
  SACRA_OHW_11_ITEM: '0xb6b462132073f6bfd3655ca09928ecc25aef62c7',
  SACRA_THW_8_ITEM: '0x1bbfcb356b6000309543dea3f93a4a9538b51635',
  SACRA_THW_9_ITEM: '0xa9980c3e49c031303b8b53c5eba4fc88e963c223',
  SACRA_THW_11_ITEM: '0x0300bff34f44a60cbc80352223a0ad3c63434798',
  SACRA_REFLECTION_ITEM: '0x0207ed5deb84565cff0a42d1a81ade53a4e7855f',
  SACRA_SCARLET_BRANCH_ADEPT_ITEM: '0xce2eb519910fabeab25df42bbb8827aae1a6f525',
  SACRA_ANATHEMA_ITEM: '0x759e6118977d76746bb0c1030a04a81a2b0bbefd',
  SACRA_GIANTS_BLOOD_ITEM: '0x9e31fc14f1b649af154e2acaa9618caf22c42bcf',
  SACRA_BACKSTAB_ITEM: '0x725502c2c382758dfd650146ca514e6d0e82e6b0',
  SACRA_VETERAN_CONFIDENCE_ITEM: '0xa48b08fa50f53c2890130addef64042f20a4b20d',
  SACRA_LIVE_FORTRESS_ITEM: '0x1eee381ae2b414924d0a7430607b1dc8b83ea25b',
  SACRA_COLD_SHOULDER_ITEM: '0x925b1e5c891cec8ce1a1be30b06a7b4ffaba29a3',
  SACRA_ERASE_ITEM: '0x9a4d7f507412d18354a05b36af18769376516f6c',
  SACRA_CONS_34_ITEM: '0x68cdc30087ad763b332a46d1343279333ca4becb',
  SACRA_CONS_36_ITEM: '0xffa9c4e19bfdd094cb1db70c3d71ea08a751b8aa',
  SACRA_CONS_37_ITEM: '0x270e82857867f331da04b377cb5d4e9bc0327fda',
  SACRA_CONS_38_ITEM: '0x470872a15ddb4805ed323626cfe5deaca5e1c2ee',
  SACRA_CONS_39_ITEM: '0x4c5e3d192bd0e189548dfa5f5ad729e4dd717945',
  SACRA_CONS_40_ITEM: '0x86b191a9f29d5b4bc89df969ff06f11029ea491a',
  SACRA_CONS_41_ITEM: '0xf050b27a7359c57207404e1bb9da7e432c6fcb90',
  SACRA_CONS_43_ITEM: '0x6c80f14ed1fbc74578f0f38ba66f79330bbcd711',
  SACRA_HELM_10_ITEM: '0x29ec0c7d7ed3a9a7bb2373b075c19d52809646ca',
  SACRA_HELM_11_ITEM: '0x6f01b2d5000e9ec7589b074b86cf170997809438',
  SACRA_BODY_9_ITEM: '0x719f2059e5ae4a90d1d719ee189db7f3951e1457',
  SACRA_BODY_10_ITEM: '0x79d86580ccc6690b95e08ce080ec92baa6646ac7',
  SACRA_BODY_11_ITEM: '0x541ba3542bd2a2cdf77b40208baea8a4faf4d9f3',
  SACRA_GLOVES_9_ITEM: '0x439e89e53ed21bf2331eafc057f26cb6ffe88d0f',
  SACRA_GLOVES_10_ITEM: '0xedea1dc9ef072f27bec28d0da9b3c74f54481a6b',
  SACRA_GLOVES_11_ITEM: '0xa0d3539942f894c1392b11dc09938ed377b90807',
  SACRA_BELT_6_ITEM: '0x0dc2066cd0724cc246b71a39cf8634512a868db2',
  SACRA_BELT_7_ITEM: '0x7e153d8fd74bfa3e5730d8aa04037d78191b3886',
  SACRA_AMULET_14_ITEM: '0x1c4b4b7f1709b35e082a97170108c07b3febbe26',
  SACRA_AMULET_15_ITEM: '0x7f52209d30790f9cf52d9895b2641650c03b40d5',
  SACRA_AMULET_16_ITEM: '0x0e2efb77de2db6288517d6413a6d40a250e37830',
  SACRA_AMULET_17_ITEM: '0x4040c1077f0397a41d246a9acfe4d5633cd0a2ce',
  SACRA_RING_12_ITEM: '0x2769f78ad07416068150777cddd1dded92851c25',
  SACRA_RING_13_ITEM: '0x2ab31a5465739d06ec227d3600343c9b3822005c',
  SACRA_RING_14_ITEM: '0xaa23dd0e2e9e7b0b5c9b8846d29fa7d374444687',
  SACRA_OFF_14_ITEM: '0xa18b4e4e0911ab2dc0607f417abf00c4a60e6c53',
  SACRA_OFF_15_ITEM: '0x030241b35b7619b3c1744298a6e058a5076d31e1',
  SACRA_OFF_16_ITEM: '0x85e5d747894d0598739898d4102fe71948b3f8f1',
  SACRA_BOOTS_8_ITEM: '0xa3742cf98cb5e94268564b0fbeb64feaac6d2a0c',
  SACRA_BOOTS_9_ITEM: '0x13d6712951081b72e2cb531606982c3fb11dac27',
  SACRA_BOOTS_10_ITEM: '0x2eb81910af03314752c65913d848770c7e169927',
  SACRA_BOOTS_11_ITEM: '0x71fa39feb21a02241261d6d9c973551122cfba94',
  SACRA_OHW_15_ITEM: '0xc60d0929e6026f84ba444c6c0bf4b110a72d0bf9',
  SACRA_OHW_16_ITEM: '0x0ee044c9ca3cbe246c35fb1ae309d3a200b3bad5',
  SACRA_OHW_17_ITEM: '0xa44634096f46857d34d7ff6379f382a549acbcea',
  SACRA_OHW_18_ITEM: '0xbcfda0a0d8360be7d593313e14e50ef5cad09407',
  SACRA_OHW_19_ITEM: '0x9562def8f23d9fda3ac58e89cf79a7db31d4db89',
  SACRA_THW_12_ITEM: '0xc9f9dd455f3c83781bcf4f6001d8bbf56aeea76c',
  SACRA_THW_13_ITEM: '0xdf746bab08aa9c895860f9c61a957fadeb1b3828',
  SACRA_THW_14_ITEM: '0x0d39640f7765117f27eb6b9061a120af918631c2',
  SACRA_THW_16_ITEM: '0x6a6e77bdb57e6a0dc9bbe2160673b80eb8fe7b8e',
  SACRA_HEAD_OFF_ITEM: '0x09545a5faafff282f5429582d2b7bbd698e53bba',
  SACRA_VOICE_OF_DEAD_GOD_ITEM: '0xc47323bd583a4097481e3ac59b05144e6fb2a49a',
  SACRA_FAST_ROLL_ITEM: '0xb6d4f55be25d99632d12a72420d80b024b450a2f',
  SACRA_MEATGRINDER_ITEM: '0xbbbe94c4e193c5b0e43aebf34c95f99769d2fd7e',
  SACRA_DEMOLDERS_TOUGHNESS_ITEM: '0xf361e78cb18d542199d4af32059867583c476a62',
  SACRA_PYROMANIAC_ITEM: '0xbd07ff9201c605e13135b378b7a0d53526406efe',
  SACRA_BLAST_ITEM: '0xcff5a6fa8f82fd9741d04b367c8783dfce012e02',
  SACRA_HORSEBREAKER_ITEM: '0xaf718d1902a6500d59b36d0beedf21d2a578ec7e',
  SACRA_FIRE_POT_ITEM: '0x014bc2ea7fe8d2869b98cdda26d7faff078b891f',
  SACRA_CONS_42_ITEM: '0x1fec7d1744508fe25801658a289708777f353124',
  SACRA_CONS_44_ITEM: '0x650c3b7cd11124880d49b46e316def7a621de242',
  SACRA_CONS_45_ITEM: '0x0bc164f7d007a5e9cf4cf1aaaaaafb12c42de684',
  SACRA_CONS_46_ITEM: '0x258daf4d95c8b2ff26d0c6726c392832dd080eb9',
  SACRA_CONS_47_ITEM: '0x7f8db650aa8f3a24512c0da7cde9265301374298',
  SACRA_CONS_48_ITEM: '0x00af41025624279d7861d8f90bfc1b4016755c52',
  SACRA_CONS_59_ITEM: '0x10c929c5365e8720ce380f68671af20ce5e175ef',
  SACRA_CONS_60_ITEM: '0x01f06de04dbf3bc8ab696c0b41af227f361f39e3',
  SACRA_CONS_61_ITEM: '0xaf4e88c471cd32743d5e529b7375dfb7b395f3db',
  SACRA_CONS_62_ITEM: '0x6e6f12d0a55f962d0c33940be7a2531eb76c465e',
  SACRA_HELM_14_ITEM: '0x458ea4e4d4d41326cc99847b8d4b88c78f3e8b0e',
  SACRA_HELM_15_ITEM: '0xd982abfa63355e860467c3ccc7fe0e17684e4246',
  SACRA_HELM_21_ITEM: '0xa35de605d680b22fe1fa224e32317e370665732d',
  SACRA_BODY_14_ITEM: '0xa2c4d8a38f31f63630c82e8a442a9622fc8db5ab',
  SACRA_BODY_15_ITEM: '0x30c7a44640a2e86b83342096d78ccd39fc3faa80',
  SACRA_GLOVES_14_ITEM: '0xc7ae3a502befbc20a8c3f4bbd2d87892ce1f5513',
  SACRA_GLOVES_15_ITEM: '0xda859a12c6cb22e1d698b084a13560d5eb0e0f4e',
  SACRA_GLOVES_21_ITEM: '0x6ac77d53d9b6b40a98751414f2a4cc8dcfb16006',
  SACRA_BELT_9_ITEM: '0x9ec826b56121a650cb9d12d8a1abb4cb43185c37',
  SACRA_BELT_10_ITEM: '0x9af9d9b6cef4d69ebe796959814368be6b955a47',
  SACRA_BELT_11_ITEM: '0xd24957da815081fae0a2e1020059e80f7f01e322',
  SACRA_AMULET_18_ITEM: '0xf5c560de2fb4e67e45f993d4f8f29e690090ee60',
  SACRA_AMULET_19_ITEM: '0xe2e64f0a7d1cd61b625d2fb0487623453e135fb6',
  SACRA_RING_16_ITEM: '0x8e0594e94b59b77b240a6c5ac8318096cf61a14d',
  SACRA_RING_17_ITEM: '0xa2721061f7c4668d27fcb2fd3c63728f56787a78',
  SACRA_RING_18_ITEM: '0xca9b5707134fc47caa62f34ae212e868f8f8ac81',
  SACRA_RING_23_ITEM: '0xdddca58295bdb1f32ddb13f2cc2862bbd7e82dcc',
  SACRA_RING_24_ITEM: '0x034da80cc4e935951fc7d115ba78c11a1e8ad93d',
  SACRA_OFF_20_ITEM: '0xcacbf17e1b478b1f9b66fe41c526a8dfdc4193dc',
  SACRA_OFF_21_ITEM: '0x5d4e9d8be271dd388ce19b0b26af3096ef1fddb3',
  SACRA_OFF_26_ITEM: '0x192cec2da6ae4fc8f42d450c8575d0dd2717c570',
  SACRA_OFF_18_ITEM: '0xa8a8bafc9614e09052fa4c96e13a6e17edbc6ada',
  SACRA_BOOTS_14_ITEM: '0xcecd1aba156358a10066d7c77e938ff6fd246944',
  SACRA_BOOTS_15_ITEM: '0x557dc23f22dc06c0d34e218482fa37ce781f53b6',
  SACRA_BOOTS_20_ITEM: '0x895c52e63a70551db38a987e4fbcb9bbc772bb66',
  SACRA_OHW_26_ITEM: '0x782825329344b128ed5dae725b79099f56270fcc',
  SACRA_OHW_27_ITEM: '0x1da216867309a345a3fd012c73365985f944c44d',
  SACRA_OHW_28_ITEM: '0xa03247922c29b25b40c5766f0772d29e756700d6',
  SACRA_OHW_29_ITEM: '0x5edd09c8130b60047fcc1029add3f0a677393d9b',
  SACRA_OHW_21_ITEM: '0x840f72a30434a60801e380af05c50f9b89648ff6',
  SACRA_OHW_22_ITEM: '0x1f96c8ef68abf87d0fcf57393a8e8f92011d4697',
  SACRA_THW_17_ITEM: '0xdcda9dbc69101b1e5dfee0b1e3d7da3b7744049b',
  SACRA_THW_18_ITEM: '0xfc932513cfb165af97f0e7d926d7101bfe926c47',
  SACRA_THW_23_ITEM: '0x165fd4396686074a12dc27e97a44423e9b0d53c5',
  SACRA_EAT_IT_AND_SHIT_ITEM: '0xd066b291d8374ffd5616bfe3fafc94bb188c8210',
  SACRA_TO_GLORY_ITEM: '0xc1b04bfeb18870b7d42072320c2759117549ce1a',
  SACRA_NOMADS_WAY_ITEM: '0x9e43c328cebec6d73512fc52f9ec7798c444dc6c',
  SACRA_IMPERIAL_HEAD_CHARGE_ITEM: '0xd8eff5e774995fe060535144ab40b9e7f59cd614',
  SACRA_SCHOLAR_ITEM: '0x176e30894e706db180e473000d7d2a6b0c8a552a',
  SACRA_UNBREAKABLE_FAITH_ITEM: '0x94202847f384245019dcf098312b895b19d13459',
  SACRA_EXPLODING_POT_ITEM: '0x2aa5d5db96251ea780e3d8dde436c1f0e21e7bf9',
  SACRA_BREAKING_MATTER_ITEM: '0xcbc3e6d4ce59d5e5efe90abf509ad0892ff7f0ce',
  SACRA_TOUCH_OF_ENDLESS_DARKNESS_ITEM: '0x951882bc6c46e079f6c249672d5fc53d7f7276aa',
  SACRA_CONS_49_ITEM: '0xfe1342fd1294a0ef13df3e808272b6bd7720453d',
  SACRA_CONS_50_ITEM: '0xdaad6da9da1e2b6488461fa3c708eb8abfae00f6',
  SACRA_CONS_51_ITEM: '0x46a7fa4b0f3b69a8ea38812f82cd46097b7ace75',
  SACRA_CONS_52_ITEM: '0x434a998e9de1c1dcb46daeb7d72d34fa91b54ba6',
  SACRA_CONS_53_ITEM: '0xea22a66bcc7462d5f7c759cfa6c3d022044a0f0e',
  SACRA_CONS_63_ITEM: '0x29b8755ada0f09b446f3b3c7562f153dbe0c3bf6',
  SACRA_CONS_64_ITEM: '0xdc3ca8fdd1e6ab5fdc95bc70e320428f13ffc9f1',
  SACRA_CONS_65_ITEM: '0xb37923602bfda1699c54a7500e0a9d45fa3ac367',
  SACRA_CONS_66_ITEM: '0x308e7d20a6f05e04331516e6021c76a35d9fc1d2',
  SACRA_HELM_16_ITEM: '0x8019c9c02e085942f24695c916593ecc64289631',
  SACRA_HELM_17_ITEM: '0x67d228e0723a850f62069da3c28148595e485bae',
  SACRA_HELM_18_ITEM: '0x543c6af7f67c6c3193b6c552f607fdf81777f9de',
  SACRA_BODY_16_ITEM: '0xda4eafe05ba6701cacba86244466dcd3f661704d',
  SACRA_BODY_17_ITEM: '0x805c21ed2cb78c4e978aeb70e6807a42e022dff6',
  SACRA_BODY_21_ITEM: '0x38e214ee928d6d563c4e232c7c81d9f03b5ce0a4',
  SACRA_GLOVES_16_ITEM: '0x111a0a804f472d663da35b3302870788617195b6',
  SACRA_GLOVES_17_ITEM: '0x84891bf562b5ad92b0fb4169c454088dc7e959ee',
  SACRA_GLOVES_18_ITEM: '0xec351a2a7ada276b0b9cf66c1ecea1488d99c35f',
  SACRA_GLOVES_22_ITEM: '0x06bbd62cd334890493e0baea579b9a0b472d55fb',
  SACRA_BELT_12_ITEM: '0xc242cf638a6c73d4314d24a73a468c03d6742c14',
  SACRA_BELT_13_ITEM: '0x0b36594700759d9e3f37a0981ecf2414613e4086',
  SACRA_BELT_17_ITEM: '0xb9f25864d18dc9064781ee64167be16d6c5a5806',
  SACRA_AMULET_20_ITEM: '0x9155b299ae4d148e972cdbc579e4f4ffdd564429',
  SACRA_AMULET_21_ITEM: '0x8be4975b1494b8a3f4fca8f945e237035bb3f86d',
  SACRA_AMULET_22_ITEM: '0x824fc4b42dec3f2330cbf2db0777953e9c2cdc8a',
  SACRA_AMULET_25_ITEM: '0xb24235d50d46c9b6bd3d7d36b402d2eaa9cea1d6',
  SACRA_RING_19_ITEM: '0x2d6809a82032c7b5cc400b0e870d61bf98ea9da3',
  SACRA_RING_20_ITEM: '0xcbd5421f9cf4e2820bd14ec14d01799c962bd5b8',
  SACRA_RING_25_ITEM: '0x3842dc03effbcd68a2afcffa174e09051e3fda64',
  SACRA_RING_26_ITEM: '0xba3fc203849f41d5a14ba589b274e3966c128abf',
  SACRA_OFF_22_ITEM: '0xcedddd4badae86a7499b1774eea6ed26c41082bb',
  SACRA_OFF_23_ITEM: '0xbd3930bb1c0ef47f7db9b473cf93f99e1c674a79',
  SACRA_OFF_19_ITEM: '0x0471e940ba21911a94a37c6d13def7de7f4e23a6',
  SACRA_BOOTS_16_ITEM: '0xb10466f77ead4db39737e045c14c5e51dbac6776',
  SACRA_BOOTS_17_ITEM: '0xcfa1e1f8da66137c99921afcb2b3fba49c9a10ed',
  SACRA_BOOTS_21_ITEM: '0x8cda684c9f929161ad4bc8c1636a7944681f9222',
  SACRA_BOOTS_22_ITEM: '0xb5167c23a42328817593f0caec9da404782dd7fb',
  SACRA_OHW_23_ITEM: '0x48f2ed54b4c81cabeefce3c531581bf99f32fc0f',
  SACRA_OHW_30_ITEM: '0x3085aa449a7e0965bed1d7827a746a0d5b8901b3',
  SACRA_OHW_31_ITEM: '0x8cd8a01f63000f50c300f9537780024642b22467',
  SACRA_OHW_32_ITEM: '0x702efb598a58c06115a14f372a451cf602b2f55f',
  SACRA_OHW_33_ITEM: '0x0bbdc9357cd0f8bb1685c4be0f3d06ad9f782ada',
  SACRA_OHW_34_ITEM: '0x588beba004862283cba8f5c170628f7d110242da',
  SACRA_OHW_35_ITEM: '0x45f0352c1766a49fdd1fffc29c6e09e238f6c976',
  SACRA_THW_19_ITEM: '0x747bda14f2264826451660d3f3c076e0a6faf7dd',
  SACRA_THW_20_ITEM: '0xa7202b7caf08baebf208cf3c572ff1e22f9aa571',
  SACRA_THW_24_ITEM: '0x4e6ef60e73eb308b1555f87f03789fab6f03398a',
  SACRA_KING_OF_THE_MOUNTAIN_ITEM: '0x9df586540c1dc714fb2a0cfeada7133992ec90fc',
  SACRA_AWARENESS_ITEM: '0x3e68e271c2720db5612ee58439e7e3c92d55d4b5',
  SACRA_MASTER_OF_MEAN_ITEM: '0x33f944b6ac5e973a2258e41f0ba38bd769485837',
  SACRA_QUEEN_OF_THE_PLAINS_ITEM: '0x7feb58f60f96f06ca982d882a3c9ffcefb19519d',
  SACRA_ARMOR_OF_DENIAL_ITEM: '0x51b2ea869fba9d3f48e33735dea28efa22a3db1c',
  SACRA_UPRISING_ITEM: '0x726416a18623013cdbe995c0a3787f4625b27d6d',
  SACRA_TOUCH_OF_DEATH_ITEM: '0xdf9a670e4ce6232917d9ea548bdcc9e0a7512d79',
  SACRA_HEAT_OF_A_THOUSAND_SUNS_ITEM: '0x0f6473e580f5cbbd21cef979f41bd64198c0860d',
  SACRA_MASTERSTROKE_ITEM: '0x1241caf434ceeaa4ea1505088c409f5f9be259a9',
  SACRA_BARD_SCREAM_ITEM: '0x6fb7536252d5a7c7f2b4c7e44fbcb9093eb10610',
};
